// AI-CONTEXT: See docs/test-runs/2026-10-21-rapportages-titel-kopie-deelnemer.md (B4)
import { copyReportName } from './buildReportCopy';
import { getEditorUrl } from './editorUrl';

/**
 * 'Kopiëren' vanuit een geopend rapport (bouwer én viewer): maakt de kopie,
 * opent hem, en zegt het. Zonder die melding wisselde alleen de url en de
 * titel, dus wie doorwerkte wist niet of hij in het origineel of de kopie zat.
 * De melding gaat via de globale snackbar, die de navigatie overleeft.
 *
 * @param {object} args
 * @param {import('../../../../types/LiveReports2').LiveReports2Doc} args.report - Het rapport dat gekopieerd wordt
 * @param {(source: object, isTemplate: boolean, name: string) => Promise<{ID: string}>} args.createNewReportFromSource
 * @param {(url: string) => void} args.navigate - Meestal `history.push`
 * @param {(message: string) => void} args.notify - Meestal `setSavedMessage` uit SavedIcon
 * @returns {Promise<void>}
 */
const duplicateReport = async ({ report, createNewReportFromSource, navigate, notify }) => {
    // Een kopie van een template is weer een template.
    const isTemplate = report.IsTemplate ?? false;
    const name = copyReportName(report);
    let newReport;
    try {
        newReport = await createNewReportFromSource(report, isTemplate, name);
    } catch (error) {
        console.error('Error copying report:', error);
        notify(`${report.Name} kon niet gekopieerd worden. Probeer het opnieuw.`);
        return;
    }
    navigate(getEditorUrl(newReport.ID, isTemplate));
    notify(`Je werkt nu in de kopie '${name}'.`);
};

export default duplicateReport;
